<template>
    <div>
        <button class="btn btn-sm btn-dark mb-1" v-on:click="back">
            <feather-icon icon="ArrowLeftIcon" class="mr-25"></feather-icon>Geri
        </button>

        <b-alert variant="warning" :show="showSlowWarning" class="mb-1">
            <div class="d-flex align-items-center">
                <b-spinner small variant="warning" class="mr-1"></b-spinner>
                <div>
                    <strong>İstek süresi uzuyor…</strong>
                    Eğer bekleme süreniz uzadıysa ve verileriniz hâlâ gelmiyorsa lütfen sistem yöneticinize bildiriniz.
                </div>
            </div>
        </b-alert>

        <b-modal size="sm" id="send-extre" title="Ekstre Gönder" no-close-on-esc no-close-on-backdrop>
            <send-extre v-model="extre"></send-extre>
            <template #modal-footer><v-executer class="ml-1" :loading="loadingExtre" :action="sendExtre" text="Gönder"></v-executer></template>
        </b-modal>

        <b-modal size="sm" id="create-payment-without-invoice" title="Faturasız Ödeme Oluştur" no-close-on-esc no-close-on-backdrop>
            <customer-account-create-payment-without-invoice v-model="PWOI"></customer-account-create-payment-without-invoice>
            <template #modal-footer><v-executer class="ml-1" :loading="loadingWithoutInvoice" :action="createPaymentWithoutInvoice" text="Oluştur"></v-executer></template>
        </b-modal>

        <b-modal size="sm" id="confirm-master" body-class="p-50" title="Yönetici Onay Metni" no-close-on-esc no-close-on-backdrop>
            <textarea class="form-control resize-none" v-model="confirmText" placeholder="Yönetici Onay Metni"></textarea>
            <template #modal-footer><v-executer class="ml-1" :loading="confirmLoading" :action="confirmMaster" text="Gönder"></v-executer></template>
        </b-modal>

        <b-modal size="sm" id="send-delivery-code" title="Teslimat Kodu" no-close-on-esc no-close-on-backdrop>
            <div v-if="deliveryCode.BelgeNo">
                <div class="mb-1"><b>Cari:</b> {{ stats.CariDetail.CARI_ISIM }}</div>
                <div class="mb-1"><b>Belge No:</b> {{ deliveryCode.BelgeNo }}</div>
                <div class="mb-1"><b>Teslim Telefon:</b> {{ maskedDeliveryPhone }}</div>
                <div class="text-muted small mb-1">
                    Teslimat doğrulama kodu, cariye tanımlanmış teslim telefon numarasına SMS ile gönderilecektir.
                </div>

                <div v-if="deliveryCode.Sent" class="alert alert-success mb-1 p-50">
                    Teslimat kodu SMS olarak gönderildi.
                </div>

                <div v-if="deliveryCode.Verified" class="alert alert-success mb-0 p-50">
                    Teslimat kodu doğrulandı. ✓
                </div>

                <template v-else>
                    <div v-if="deliveryCode.Sent">
                        <label class="form-label">Müşterinin Söylediği Kod</label>
                        <input class="form-control"
                               type="text"
                               v-model="deliveryCode.InputCode"
                               placeholder="Teslimat kodunu giriniz"
                               maxlength="10" />
                        <div v-if="deliveryCode.VerifyError" class="text-danger small mt-50">
                            {{ deliveryCode.VerifyError }}
                        </div>
                    </div>
                </template>
            </div>
            <template #modal-footer>
                <v-executer
                    v-if="!deliveryCode.Verified"
                    :loading="deliveryCode.Loading"
                    :action="sendDeliveryCode"
                    variant="secondary"
                    :text="deliveryCode.Sent ? 'Yeniden Gönder' : 'Gönder'">
                </v-executer>
                <v-executer
                    v-if="deliveryCode.Sent && !deliveryCode.Verified"
                    class="ml-1"
                    :loading="deliveryCode.VerifyLoading"
                    :action="verifyDeliveryCode"
                    variant="success"
                    :disabled="!deliveryCode.InputCode"
                    text="Doğrula">
                </v-executer>
            </template>
        </b-modal>

        <!-- Özel Kontrol Stok durumu modalı (içinde bulunulan ay) -->
        <b-modal size="md" id="special-stock-status" ok-only ok-title="Kapat"
                 :title="`Özel Kontrol Stok Durumu — ${specialStockMonthLabel}`"
                 v-on:hide="specialStock.alertShown = true">
            <div v-if="specialStock.loading" class="text-center text-muted p-1">
                <b-spinner small class="mr-50"></b-spinner> Yükleniyor...
            </div>
            <div v-else-if="specialStock.data">
                <div class="mb-1">
                    <b-badge :variant="specialStockMissing ? 'light-danger' : 'light-success'">
                        {{ specialStock.data.PurchasedCount }} / {{ specialStock.data.TotalCount }} özel kalem alındı
                    </b-badge>
                </div>
                <div v-for="it in specialStock.data.Items" :key="it.StockCode"
                     class="d-flex align-items-center py-50 scsd-item">
                    <span class="material-icons-round mr-1" :class="it.Purchased ? 'text-success' : 'text-danger'">
                        {{ it.Purchased ? 'check_circle' : 'cancel' }}
                    </span>
                    <div class="flex-grow-1">
                        <div>{{ it.StockName || '-' }}</div>
                        <small class="text-muted">{{ it.StockCode }}</small>
                    </div>
                    <b-badge :variant="it.Purchased ? 'light-success' : 'light-danger'">
                        {{ it.Purchased ? 'Alındı' : 'Alınmadı' }}
                    </b-badge>
                </div>
                <div v-if="!specialStock.data.Items || specialStock.data.Items.length === 0" class="text-muted">
                    Tanımlı özel kontrol stoğu bulunmuyor.
                </div>
            </div>
        </b-modal>

        <div class="cad-stats">
            <div class="row" v-if="statsLoading || stats.CariDetail.CARI_KOD != null">
                <div class="col-md-12 mb-1">
                        <v-stats-box text="Cari Bilgisi" variant="warning" icon="business" :loading="statsLoading"
                        :value="`${stats.CariDetail.CARI_KOD || '' } - ${stats.CariDetail.CARI_ISIM || '-'} - ${stats.CariDetail.CARI_ADRES|| '-' } - ${stats.CariDetail.CARI_TEL|| '-' }`" ></v-stats-box>
                </div>
            </div>

            <!-- Özel kontrol stok: bu cari bu ay bazı özel ürünleri almadıysa yanıp sönen gösterge + kırmızı alert -->
            <div class="row" v-if="specialStockMissing">
                <div class="col-md-12 mb-1">
                    <button class="btn btn-danger scsd-blink d-inline-flex align-items-center"
                            v-on:click="openSpecialStockModal">
                        <span class="material-icons-round mr-50">warning</span>
                        Bu cari bu ay bazı özel ürünleri almadı — detay için tıklayın
                    </button>
                    <b-alert variant="danger" :show="specialStock.alertShown" class="mt-1 mb-0">
                        <div class="alert-body">
                            <div class="font-weight-bolder mb-25">
                                <span class="material-icons-round mr-50 align-middle">report</span>
                                {{ specialStockMonthLabel }} ayında alınmayan özel ürünler ({{ specialStockMissingItems.length }}):
                            </div>
                            <ul class="mb-0 pl-2">
                                <li v-for="it in specialStockMissingItems" :key="it.StockCode">
                                    {{ it.StockName || '-' }} <span class="text-muted">({{ it.StockCode }})</span>
                                </li>
                            </ul>
                        </div>
                    </b-alert>
                </div>
            </div>

            <div class="row">
                    <div class="col-4 mb-1">
                        <v-stats-box text="Alacak Toplam" variant="warning" icon="currency_lira" :loading="statsLoading" :value="stats.AlacakToplam" ></v-stats-box>
                    </div>
                    <div class="col-4 mb-1">
                        <v-stats-box text="Borç Toplam" variant="danger" icon="currency_lira" :loading="statsLoading" :value="stats.BorcToplam" ></v-stats-box>
                    </div>
                    <div class="col-4 mb-1">
                        <v-stats-box text="Bakiye Toplam" variant="success" icon="currency_lira" :loading="statsLoading" :value="stats.BakiyeToplam" ></v-stats-box>
                    </div>
            </div>
        </div>
        <b-card no-body class="cad-table">
            <div class="d-flex justify-content-between align-items-center flex-wrap px-1 pt-1">
                <b-form-checkbox v-model="onlyOpen" switch class="cad-filter-switch" v-on:change="onFilterChange">
                    Sadece açık faturalar
                </b-form-checkbox>
                <div class="d-flex align-items-center flex-wrap">
                    <button class="btn btn-sm btn-flat-secondary" v-on:click="showStatusLegend = !showStatusLegend">
                        <feather-icon :icon="showStatusLegend ? 'ChevronUpIcon' : 'ChevronDownIcon'" class="mr-25"></feather-icon>
                        Durum Açıklamaları
                    </button>
                </div>
            </div>
            <b-collapse v-model="showStatusLegend">
                <div class="bg-light rounded mx-1 mb-1 p-75">
                    <div class="d-flex flex-wrap">
                        <div v-for="s in statusLegend" :key="s.key" class="d-flex align-items-center mr-2 mb-50">
                            <b-badge :variant="s.variant" pill class="v-status-badge d-inline-flex align-items-center mr-50">
                                <span class="material-icons-round v-status-badge-icon">{{ s.icon }}</span>
                            </b-badge>
                            <small class="text-nowrap">{{ s.label }}</small>
                        </div>
                    </div>
                </div>
            </b-collapse>
            <v-table    ref="table"
                        :items-provider="provider"
                        pagination="server"
                        search
                        selectable
                        :buttons="buttons"
                        v-on:select="selecteds = $event"
                        :row-selectable="rowSelectable"
                        :row-class="rowClass"
                        :initial-per-page="2000"
                        :per-pages="[50,100,250,500,1000,2000]"
                        :fields="fields">
                            <template #additional-actions>
                            <div class="row cad-actions">
                                <div class="col-auto">
                                    <v-executer variant="success" :loading="loading" :action="dateControlForInstallment" :disabled="selecteds.length == 0">
                                        ({{selecteds.length}}) ({{ totalSelected }}₺) Seçilen Faturalar İçin Ödeme Oluştur
                                    </v-executer>
                                    <v-executer class="ml-1" v-if="isHasFaturasizGonderimRaporuRole" :action="createPaymentWithoutInvoiceModal" text="Faturasız Ödeme Oluştur"></v-executer>
                                    <v-executer class="ml-1" :action="ekstreModalOpen" text="Ekstre Gönder"></v-executer>
                                </div>
                            </div>
                            </template>
                        </v-table>
        </b-card>
    </div>
</template>

<script>
import { NetsisApi } from '@/api/netsis'
import {PaymentApi} from '@/api/payment'
import { BCard, BAlert, BCollapse, BBadge, BSpinner, BFormCheckbox } from 'bootstrap-vue'
import VStatsBox from '@/components/VStatsBox.vue'
import CustomerAccountCreatePaymentWithoutInvoice from './components/CustomerAccountCreatePaymentWithoutInvoice.vue'
import SendExtre from './components/SendExtre.vue'
import { PAYMENT_POOL_STATUS } from '@/views/common/customer/CustomerPaymentStatusBadge.vue'
import randomatic from 'randomatic'
import moment from 'moment'
import Auth from '@/utilities/auth'
import { ReportApi } from '@/api/report'

const TR_MONTHS = ['Ocak','Şubat','Mart','Nisan','Mayıs','Haziran','Temmuz','Ağustos','Eylül','Ekim','Kasım','Aralık']

export default {
    components:{
        BCard,
        BAlert,
        BCollapse,
        BBadge,
        BSpinner,
        BFormCheckbox,
        VStatsBox,
        CustomerAccountCreatePaymentWithoutInvoice,
        SendExtre
    },
    data() {
        return {
            loading:false,
            loadingWithoutInvoice:false,
            loadingExtre:false,
            statsLoading:false,
            activeRequests:0,
            showSlowWarning:false,
            showStatusLegend:false,
            onlyOpen:false,
            code: this.$route.params?.code || null,
            buttons:[
                { text:"Faturayı E-Posta İle Gönder",key:"edit",icon:"SendIcon",variant:"secondary",action:this.sendInvoiceDetail,condition:(item) => item.HareketTuru == 'FATURA'},
                { text:"Faturayı Detayı Görüntüle",key:"detail",icon:"EyeIcon",variant:"primary",action:this.getInvoiceDetail,condition:(item) => item.HareketTuru == 'FATURA'},
                { text:"Teslimat Kodu Oluştur",key:"delivery-code",icon:"TruckIcon",variant:"info",action:this.openDeliveryCodeModal,condition:(item) => this.canSendDeliveryCode(item)},
            ],
            stats:{
                AlacakToplam:null,
                BorcToplam:null,
                BakiyeToplam:null,
                CariDetail:{
                    CARI_ISIM:'',
                    CARI_ADRES:'',
                    CARI_TEL:'',
                    CARI_KOD:''
                }
            },
            PWOI:{
                CariCode:null,
                DocumentNo:null,
                Tarih :null,
                Tutar :null,
                VadeTarihi :null,
                Order :null,
                IsWithoutInvoice :null,
                CanInstallment:false,
                Description:null
            },
            selecteds:[],
            confirmLoading:false,
            confirmText:null,
            extre: {
                Email:null
            },
            faturaDetayi:{
                Email:null,
                CariCode:null
            },
            deliveryCode:{
                BelgeNo:null,
                Loading:false,
                Sent:false,
                InputCode:'',
                VerifyLoading:false,
                Verified:false,
                VerifyError:null,
                MaskedPhone:null,
                HasDeliveryPhone:false
            },
            specialStock:{
                loading:false,
                data:null,
                alertShown:false
            }
        }
    },
    mounted(){
        this.loadSpecialStockStatus()
    },
    methods:{
        loadSpecialStockStatus(){
            if(!this.code) return
            this.specialStock.loading = true
            this.specialStock.alertShown = false
            ReportApi.CariSpecialControlStockStatus(this.code).then(res=>{
                this.specialStock.data = (res.data && res.data.Data) ? res.data.Data : null
                // Eksik ürün varsa kullanıcının dikkatini çekmek için modalı otomatik aç.
                if(this.specialStock.data && this.specialStock.data.HasMissing){
                    this.$showModal('special-stock-status')
                }
            }).catch(()=>{
                this.specialStock.data = null
            }).finally(()=>{
                this.specialStock.loading = false
            })
        },
        openSpecialStockModal(){
            this.$showModal('special-stock-status')
        },
        rowClass(item){
            if(this.hasDeliveryCodeRole && item && item.IsDeliveryVerified){
                return 'v-delivery-verified-row'
            }
            return null
        },
        canSendDeliveryCode(item){
            if(!Auth.hasRole(['SEND_DELIVERY_CODE'])) return false
            if(!item || !item.BelgeNo) return false
            return !item.BelgeNo.toString().trim().toUpperCase().startsWith('KR')
        },
        openDeliveryCodeModal(item){
            this.deliveryCode.BelgeNo = item.BelgeNo
            this.deliveryCode.Sent = false
            this.deliveryCode.Loading = false
            this.deliveryCode.InputCode = ''
            this.deliveryCode.VerifyLoading = false
            this.deliveryCode.Verified = false
            this.deliveryCode.VerifyError = null
            this.deliveryCode.MaskedPhone = null
            this.deliveryCode.HasDeliveryPhone = false
            this.$showModal('send-delivery-code')
            NetsisApi.GetCustomerDeliveryPhone(this.code).then(res=>{
                if(res.data.Success && res.data.Data){
                    this.deliveryCode.MaskedPhone = res.data.Data.MaskedPhone
                    this.deliveryCode.HasDeliveryPhone = res.data.Data.HasDeliveryPhone
                }
            }).catch(()=>{})
        },
        sendDeliveryCode(){
            this.deliveryCode.Loading = true
            this.deliveryCode.VerifyError = null
            return NetsisApi.SendDeliveryCode(this.code, this.deliveryCode.BelgeNo).then(res=>{
                this.$result(res)
                if(res.data.Success){
                    this.deliveryCode.Sent = true
                    this.deliveryCode.InputCode = ''
                    this.deliveryCode.Verified = false
                }
                this.deliveryCode.Loading = false
            }).catch(err=>{
                this.deliveryCode.Loading = false
                this.$result(null,err)
            })
        },
        verifyDeliveryCode(){
            if(!this.deliveryCode.InputCode){
                this.deliveryCode.VerifyError = 'Lütfen teslimat kodunu giriniz.'
                return
            }
            this.deliveryCode.VerifyLoading = true
            this.deliveryCode.VerifyError = null
            return NetsisApi.VerifyDeliveryCode(this.code, this.deliveryCode.BelgeNo, this.deliveryCode.InputCode.trim()).then(res=>{
                if(res.data.Success){
                    this.deliveryCode.Verified = true
                    this.$result(res)
                    this.$hideModal('send-delivery-code')
                    if(this.$refs.table) this.$refs.table.refresh()
                }else{
                    this.deliveryCode.VerifyError = res.data.Message || 'Girilen teslimat kodu hatalı.'
                    this.$result(res)
                }
                this.deliveryCode.VerifyLoading = false
            }).catch(err=>{
                this.deliveryCode.VerifyLoading = false
                this.deliveryCode.VerifyError = 'Doğrulama sırasında bir hata oluştu.'
                this.$result(null,err)
            })
        },
        getInvoiceDetail(item){
            const routeData = this.$router.resolve({name:'invoice-detail-from-netsis',params: { customerCode: this.faturaDetayi.CariCode || this.code,documentNumber:item.BelgeNo }});
            window.open(routeData.href, '_blank');

        },
        sendInvoiceDetail(item){
            NetsisApi.FaturaDetayGonder(this.faturaDetayi.Email,this.faturaDetayi.CariCode,item.BelgeNo).then(res=>{
                this.$result(res)
            })
        },
        // Sayfadaki herhangi bir istek 5 sn'yi aşarsa tekil bir uyarı gösterir,
        // tüm istekler sonuçlandığında uyarı kalkar.
        trackRequest(promise){
            this.activeRequests++
            const timer = setTimeout(()=>{ this.showSlowWarning = true }, 5000)
            const done = ()=>{
                clearTimeout(timer)
                this.activeRequests = Math.max(0, this.activeRequests - 1)
                if(this.activeRequests === 0) this.showSlowWarning = false
            }
            promise.then(done, done)
            return promise
        },
        provider(data){
            this.getStats()
            return this.trackRequest(NetsisApi.CustomerAccountAction({
                CariCode:this.code,
                OnlyOpenInvoices:this.onlyOpen,
                PaginationRequestModel:data
            }))
        },
        onFilterChange(){
            if(this.$refs.table) this.$refs.table.refresh()
        },
        sendExtre(){
            this.loadingExtre=true
            return NetsisApi.SendExtre(this.code,this.extre.Email).then(res => {
                this.$result(res)
                if(res.data.Success){
                    this.$hideModal('send-extre')
                }
                this.loadingExtre = false
            }).catch(err=> {
                this.loadingExtre=false
                this.$result(null,err)
            })
        },
        ekstreModalOpen(){
            this.clearForm()
            this.$showModal('send-extre')
        },
        rowSelectable(item,items){
            return item.IsPayable && ( item.PaymentPoolStatus == null || item.PaymentPoolStatus == 4 || item.PaymentPoolStatus == 1 || item.PaymentPoolStatus == 2 || item.IsPartialAndLastInvoiceDatePassed ==true) 
        }, 
        clearForm(){
            this.PWOI.CariCode = this.code
            this.PWOI.Tutar = 0
            this.PWOI.DocumentNo = 'W' + randomatic('A',7)
            this.PWOI.Tarih = moment().format('YYYY-MM-DD')
            this.PWOI.VadeTarihi = moment().add(1,'days').format('YYYY-MM-DD')
            this.PWOI.Order = 0
            this.PWOI.IsWithoutInvoice = true
            this.PWOI.CanInstallment = false
            this.PWOI.Description=null
        },
        createPaymentWithoutInvoiceModal(){
            this.clearForm()
            this.$showModal('create-payment-without-invoice')
        },
        createPaymentWithoutInvoice(){
            this.loadingWithoutInvoice = true
            if(!this.PWOI.Tutar) this.PWOI.Tutar = 0
            PaymentApi.CreatePaymentRequest([this.PWOI]).then(res => {
                this.$result(res)
                if(res.data.Success){
                    this.$hideModal('create-payment-without-invoice')
                }
                this.loadingWithoutInvoice =false
            }).catch(err=>{
                this.$result(null,err)
                this.loadingWithoutInvoice = false
            })
        },
        getStats(){
            this.statsLoading = true
            return this.trackRequest(NetsisApi.CustomerAccountActionStats(this.code)).then(res=>{
                if(res.data.Success){
                    this.stats.AlacakToplam=res.data.Data.AlacakToplam
                    this.stats.BorcToplam=res.data.Data.BorcToplam
                    this.stats.BakiyeToplam=res.data.Data.BakiyeToplam
                    this.stats.CariDetail.CARI_ISIM=res.data.Data.CariDetail.CARI_ISIM
                    this.stats.CariDetail.CARI_ADRES=res.data.Data.CariDetail.CARI_ADRES
                    this.stats.CariDetail.CARI_TEL=res.data.Data.CariDetail.CARI_TEL
                    this.stats.CariDetail.CARI_KOD=res.data.Data.CariDetail.CARI_KOD
                    this.extre.Email = res.data.Data.CariDetail.CARI_EMAIL
                    this.faturaDetayi.Email =res.data.Data.CariDetail.CARI_EMAIL
                    this.faturaDetayi.CariCode=res.data.Data.CariDetail.CARI_KOD
                }else{
                    this.$result(res) // Netsis sunucusundan kaynaklı olarak ara sıra verinin gelmemesi durumu için tekrar kontrol amaçlı yapılmıştır.
                }
            }).finally(()=>{
                this.statsLoading = false
            })
        },
        back(){
            this.$router.push({name:'customer-account'})
        },
        confirmMaster(){
            let controlData = this.selecteds.map((c) => {
                return {
                    Tutar:c.KalanBorc,
                    Tarih:c.Tarih,
                    CariCode:c.CariKod,
                    DocumentNo:c.BelgeNo,
                    VadeTarihi:c.VadeTarihi,
                    Description:this.confirmText
                }
            })
            this.confirmLoading = true
            PaymentApi.CreateResponsibleUserApproveRequest(controlData).then(res=> {
                this.$result(res)
                this.selecteds =[]
                this.$refs.table.refresh()
                this.loading =false
                this.confirmLoading = false
                this.$hideModal('confirm-master')
            }).catch(err=>{
                console.log(err)
                this.$hideModal('confirm-master')
                this.loading =false
                this.$result(null,err)
            })

        },
        dateControlForInstallment(){
            this.loading = true
            let controlData = this.selecteds.map((c) => {
                return {
                    Tutar:c.KalanBorc,
                    Tarih:c.Tarih,
                    CariCode:c.CariKod,
                    DocumentNo:c.BelgeNo,
                    VadeTarihi:c.VadeTarihi
                }
            })
            PaymentApi.DateControlForInstallment(controlData).then(res => {
                
                const data=res.data.Data
                if(!res.data.Success){
                    this.$result(res)
                    this.loading =false
                }
                if(res.data.Success){

                     // 1- Seçili tüm faturalar güneş faturası olduğu durumlar ve Seçili tüm faturaların vade tarihi geçmiş olabilir | Bu durumda direkt olarak ödeme taksit olmadan ödeme alınması söz konusudur.
                    if(!data.DevirFaturaMi &&!data.JanuaryControl && data.SunCampaignProductControl && !data.IsCanBeInstallment && data.SunCampaignProductMessage != null){
                        this.$confirm('Ödeme İşlemi Onayı',`${data.SunCampaignProductMessage} faturalarına ait vade tarihi geçmiş ödemeler mevcut. Bu faturalara taksit yapılamaz. Onaylıyor musunuz?`,"Tek Çekim").then(result=>{
                            if(result){
                                PaymentApi.CreatePaymentRequest(controlData).then(res => {
                                    this.$result(res)
                                    this.selecteds =[]
                                    this.$refs.table.refresh()
                                    this.loading =false
                                })
                            }else{
                                this.loading =false
                            }
                        })   
                    }
                    // 01.01.2024 faturalı
                    if(data.DevirFaturaMi && !data.IsCanBeInstallment ){
                        this.$confirm('Ödeme İşlemi Onayı',`Seçilen ${this.selecteds.length > 1 ? 'faturalar':'fatura'} için devir işlemi söz konusu olduğundan (01.01.2024) taksitli ödeme yapılamaz. Fatura(lar) tek çekim gönderilecektir. Onaylıyor musunuz?`).then(result=>{
                            if(result){
                                PaymentApi.CreatePaymentRequest(controlData).then(res => {
                                    this.$result(res)
                                    this.selecteds =[]
                                    this.$refs.table.refresh()
                                    this.loading =false
                                })
                            }else{
                                this.loading =false
                            }
                        })   
                    }
                    // 3- Seçili tüm faturalar güneş faturası olduğu durumlar ve Seçili faturaların hiçbirinin vade tarihi geçmemiş olabilir
                    if(!data.DevirFaturaMi && !data.JanuaryControl && data.SunCampaignProductControl && data.IsCanBeInstallment && data.SunCampaignProductMessage == null){
                        this.$confirm('Ödeme İşlemi Onayı',`Seçili faturaların tamamı Güneş ürünlerini içermektedir. İşletmenizin kuralları gereği ilgili faturalara vade tarihi geçmediği için taksit yapılabilir. Onaylıyor musunuz?`,"Taksit").then(result=>{
                            if(result){
                                PaymentApi.CreatePaymentRequest(controlData).then(res => {
                                    this.$result(res)
                                    this.selecteds =[]
                                    this.$refs.table.refresh()
                                    this.loading =false
                                })
                            }else{
                                this.loading =false
                            }
                        })   
                    }


                    if(!data.DevirFaturaMi &&!data.SunCampaignProductControl && data.JanuaryControl && data.IsCanBeInstallment && data.JanuaryControlCheck!= null){
                        this.$confirm('Ödeme İşlemi Onayı',`Seçilen ${this.selecteds.length > 1 ? 'faturalar':'fatura'} için Ocak ve Şubat ayı kontrolü geçerlidir. Taksitli şekilde ödeme yapılabilir. Müşteriye ödeme bilgilendirmesi taksit seçenekleri ile birlikte sunulacaktır. Onaylıyor musunuz?`,"Taksit").then(result=>{
                            if(result){
                                PaymentApi.CreatePaymentRequest(controlData).then(res => {
                                    this.$result(res)
                                    this.selecteds =[]
                                    this.$refs.table.refresh()
                                    this.loading =false
                                })
                            }else{
                                this.loading =false
                            }
                        })                        
                    }

                    if(!data.DevirFaturaMi &&!data.SunCampaignProductControl && !data.JanuaryControl && data.NotPaidInvoicesBeforeDueDate != null && data.NotPaidInvoicesBeforeDueDate.length>0 && data.IsHaveNotPaidInvoicesBeforeDueDate && !data.IsCanBeInstallment ){
                        let invoices = data.NotPaidInvoicesBeforeDueDate.map(i=>i.DocumentNo).join(', ')
                        this.$confirm('Ödeme İşlemi Onayı',`Seçilen ${this.selecteds.length > 1 ? 'faturalar':'fatura'} için işletme kurallarınız gereği  müşterinin öncelikli olarak ödemesi gereken, vade tarihini aşan faturaların numarası şu şekildedir: ${invoices}. Sistem bu faturalara sadece tek çekim üzerinden ödeme bilgisi gönderebilir. Onaylıyor musunuz?` ,"Tek Çekim").then(result=>{
                            if(result){
                                PaymentApi.CreatePaymentRequest(data.NotPaidInvoicesBeforeDueDate).then(res => {
                                    this.$result(res)
                                    this.selecteds =[]
                                    this.$refs.table.refresh()
                                    this.loading =false
                                })
                            }else{
                                this.loading =false
                            }
                        })
                    }
                    

                    if(!data.DevirFaturaMi &&!data.SunCampaignProductControl && !data.JanuaryControl &&data.IsLowerInstallmentLimitRule && !data.IsHaveNotPaidInvoicesBeforeDueDate){
                        this.$confirm('Ödeme İşlemi Onayı',`Seçilen ${this.selecteds.length > 1 ? 'faturalar':'fatura'} için işletme kurallarınız gereği ${data.LowerInstallmentLimit} ₺ tutarının altındaki tutarlara taksit yapılamaz. Ödeme bilgisi müşteriye tek çekim üzerinden gönderilecektir. Onaylıyor musunuz?` ,"Tek Çekim").then(result=>{
                            if(result){
                                PaymentApi.CreatePaymentRequest(controlData).then(res => {
                                    this.$result(res)
                                    this.selecteds =[]
                                    this.$refs.table.refresh()
                                    this.loading =false
                                })
                            }else{
                                this.loading =false
                            }
                        })
                    }
                    if(!data.DevirFaturaMi &&!data.SunCampaignProductControl && !data.JanuaryControl &&data.IsCanBeInstallment && !data.IsLowerInstallmentLimitRule && !data.IsHaveNotPaidInvoicesBeforeDueDate){
                        this.$confirm('Ödeme İşlemi Onayı',`Seçilen ${this.selecteds.length > 1 ? 'faturalar':'fatura'} için ortalama vade gün sayısı ${data.AvarageDate} gündür. Taksitli şekilde ödeme yapılabilir. Müşteriye ödeme bilgilendirmesi taksit seçenekleri ile birlikte sunulacaktır. Onaylıyor musunuz?`,"Taksit").then(result=>{
                            if(result){
                                PaymentApi.CreatePaymentRequest(controlData).then(res => {
                                    this.$result(res)
                                    this.selecteds =[]
                                    this.$refs.table.refresh()
                                    this.loading =false
                                })
                            }else{
                                this.loading =false
                            }
                        })
                    }
                    if(!data.DevirFaturaMi &&!data.SunCampaignProductControl && !data.JanuaryControl &&!data.IsCanBeInstallment && !data.IsLowerInstallmentLimitRule && !data.IsHaveNotPaidInvoicesBeforeDueDate){
                        this.$confirm('Ödeme İşlemi Onayı',`Seçilen ${this.selecteds.length > 1 ? 'faturaların':'faturanın'} ortalama vade gün sayısı ${data.AvarageDate} gündür. İşletmenizin kuralları gereği seçilen ${this.selecteds.length > 1 ? 'faturalara':'faturaya'} ait taksitlendirme işlemi gerçekleştirilemez. Eğer taksitlendirme işlemi gerçekleştirmek istiyorsanız bunu yöneticiniz onayı ile yapmak zorundasınız. Onaylıyor musunuz?`).then(result=>{
                            if(result){
                                this.$confirm('Taksit Onay','Bu ödeme işlemi için taksitlendirme yapmak istiyorsanız yöneticinize onay bilgilendirmesi gidecektir.','Onay Al','Tek Çekim').then(res=>{
                                    if(res == true){
                                        this.$showModal('confirm-master')
                                    }else if(res == false){
                                        PaymentApi.CreatePaymentRequest(controlData).then(res => {
                                            this.$result(res)
                                            this.selecteds =[]
                                            this.$refs.table.refresh()
                                            this.loading =false
                                        })
                                    }
                                })
                            }else{
                                this.loading =false
                            }
                        })
                    }
                }
            }).catch(err=>{
                this.loading =false
                this.$result(null,err)
            })
        }
    },
    computed:{
        specialStockMonthLabel(){
            const d = new Date()
            return `${TR_MONTHS[d.getMonth()]} ${d.getFullYear()}`
        },
        specialStockMissing(){
            return !!(this.specialStock.data && this.specialStock.data.HasMissing)
        },
        specialStockMissingItems(){
            if(!this.specialStock.data || !this.specialStock.data.Items) return []
            return this.specialStock.data.Items.filter(i => !i.Purchased)
        },
        isHasFaturasizGonderimRaporuRole(){
            return Auth.hasRole(['SEND_PAYMENT_LINK_WITHOUT_INVOICE'])
        },
        hasDeliveryCodeRole(){
            return Auth.hasRole(['SEND_DELIVERY_CODE'])
        },
        statusLegend(){
            return Object.entries(PAYMENT_POOL_STATUS).map(([key,val])=>({ key, ...val }))
        },
        fields(){
            return [
                { name:"Belge No",key:'BelgeNo', tdClass:'text-nowrap',thClass:'w-6'},
                { name:"Durum",key:'PaymentPoolStatus',thClass:'text-center', tdClass:'text-center', component:true, componentOptions:{ name:'customer/CustomerPaymentStatusBadge' }},
                { name:"Ödeme Linki",key:'GroupCode',thClass:'text-center', tdClass:'text-center', component:true, componentOptions:{ name:'customer/CustomerPaymentLinkButton' }},
                { name:"Tarih",key:'Tarih',thClass:'w-6', tdClass:'text-nowrap'},
                { name:"Son Taks. Tarihi",key:'InstallmentLastDay',thClass:'w-6', tdClass:'text-nowrap'},
                { name:"Vade Tarihi",key:'VadeTarihi',thClass:'w-6', tdClass:'text-nowrap'},
                { name:"Kalan Borç (TL)",key:'KalanBorcStr', tdClass:'text-nowrap text-right',thClass:'w-7',component:true, componentOptions:{ name:'customer/CustomerDebt' }},
                { name:"Borç (TL)",key:'BorcStr', tdClass:'text-nowrap text-right',thClass:'w-7'},
                { name:"Alacak (TL)",key:'AlacakStr',thClass:'w-7', tdClass:'text-nowrap text-right'},
                { name:"Kapatılmış Tutar (TL)",key:'KapatilmisTutarStr',thClass:'w-7', tdClass:'text-nowrap text-right', component:true, componentOptions:{ name:'customer/CustomerCredit' }},
                { name:"Bakiye (TL)", component:true, componentOptions:{ name:'customer/CustomerBalance' }, key:'KumilatifBakiyeStr', tdClass:'text-nowrap text-right',thClass:'w-7'},
                { name:"Açıklama",key:'Aciklama',thClass:'w-6', tdClass:'text-nowrap'},
                { name:"Hareket Türü",key:'HareketTuru', tdClass:'text-nowrap',thClass:'w-16'},
            ]
        },
        maskedDeliveryPhone(){
            return this.deliveryCode.MaskedPhone || '•••••• ••••'
        },
        totalSelected(){
            let sum = this.selecteds.reduce((sum,item)=>sum += item.KalanBorc,0)
            if(sum){
                return new Intl.NumberFormat('tr-TR', {
                    currency: 'TRY',
                    minimumFractionDigits: 2,
                }).format(sum)
            }else return "0,00"
        }
    }
}
</script>

<style>
.v-delivery-verified-row,
.v-delivery-verified-row td {
    background-color: #d4edda !important;
}

/* Özel kontrol stok: yanıp sönen (dikkat çeken) buton */
.scsd-blink {
    animation: scsd-pulse 1.2s infinite;
}
@keyframes scsd-pulse {
    0%   { box-shadow: 0 0 0 0 rgba(234, 84, 85, 0.6); }
    70%  { box-shadow: 0 0 0 12px rgba(234, 84, 85, 0); }
    100% { box-shadow: 0 0 0 0 rgba(234, 84, 85, 0); }
}
.scsd-item + .scsd-item {
    border-top: 1px solid rgba(0,0,0,0.06);
}

/* Satır yüksekliğini olabildiğince daralt */
.cad-table .v-table.table td,
.cad-table .v-table.table th{
    padding-top: 0.2rem !important;
    padding-bottom: 0.2rem !important;
    line-height: 1.15;
    vertical-align: middle;
}

/* Tüm tablo başlıkları tek satır (nowrap) */
.cad-table .v-table thead th{
    white-space: nowrap;
}

/* Sola sabit (sticky) sütunlar: Seç (1), İşlemler (2), Belge No (3).
   Genişlikler içeriğe göre seçildi; left ofsetleri bu genişliklerin toplamıdır. */
.cad-table .v-table thead th:nth-child(1),
.cad-table .v-table tbody td:nth-child(1){
    position: sticky; left: 0;
    width: 52px; min-width: 52px; max-width: 52px;
}
.cad-table .v-table thead th:nth-child(2),
.cad-table .v-table tbody td:nth-child(2){
    position: sticky; left: 52px;
    width: 116px; min-width: 116px; max-width: 116px;
}
.cad-table .v-table thead th:nth-child(3),
.cad-table .v-table tbody td:nth-child(3){
    position: sticky; left: 168px;
    width: 176px; min-width: 176px; max-width: 176px;
    box-shadow: inset -1px 0 0 #d4d2de, 6px 0 6px -4px rgba(0,0,0,.18);
}

/* Sticky hücre arka planları (kaydırınca alttaki sütunlar görünmesin) */
.cad-table .v-table tbody td:nth-child(-n+3){
    background-color: #fff;
    z-index: 2;
}
.cad-table .v-table thead th:nth-child(-n+3){
    background-color: #f3f2f7;
    z-index: 3;
}
.dark-layout .cad-table .v-table tbody td:nth-child(-n+3){
    background-color: #283046;
}
.dark-layout .cad-table .v-table thead th:nth-child(-n+3){
    background-color: #343d55;
}

/* Telefon (≤767.98px): ilk 3 sütunu sabitleme — küçük ekranda yer kalmıyor,
   tablo normal şekilde yatay kaysın. */
@media (max-width: 767.98px){
    .cad-table .v-table thead th:nth-child(1),
    .cad-table .v-table tbody td:nth-child(1),
    .cad-table .v-table thead th:nth-child(2),
    .cad-table .v-table tbody td:nth-child(2),
    .cad-table .v-table thead th:nth-child(3),
    .cad-table .v-table tbody td:nth-child(3){
        position: static;
        left: auto;
        width: auto;
        min-width: 0;
        max-width: none;
        box-shadow: none;
    }
}

/* Durum lejant badge'leri (badge bileşeni yüklenmese de görünsün) */
.cad-table .v-status-badge{
    padding: 0.25rem;
    line-height: 1;
}
.cad-table .v-status-badge-icon{
    font-size: 0.95rem;
}

/* ---------------- Telefon (≤767.98px): stat kartları + butonlar minimal ---------------- */
@media (max-width: 767.98px){
    /* Cari bilgisi + stat kartları: minimal */
    .cad-stats .card-body{
        padding: 0.45rem 0.4rem;
    }
    .cad-stats h2{
        margin-bottom: 0 !important;
    }
    /* Cari bilgisi kartı (1. satır, uzun metin): sarmaya devam etsin */
    .cad-stats .row:first-child h2{
        font-size: 0.9rem;
        white-space: normal;
        word-break: break-word;
    }
    .cad-stats .row:first-child .truncate{
        overflow: visible;
        white-space: normal;
    }
    /* Tutar kartları (2. satır): rakam ASLA kaymasın → tek satır, sığacak şekilde küçük */
    .cad-stats .row:last-child h2{
        font-size: 0.78rem;
        white-space: nowrap;
    }
    .cad-stats .row:last-child .truncate{
        overflow: visible;
        white-space: nowrap;
    }
    .cad-stats .card-body span{
        font-size: 0.7rem;
    }
    /* Tutar kartlarında avatar ikonunu gizleyip yer kazan */
    .cad-stats .row:last-child .b-avatar{
        display: none !important;
    }
    .cad-stats .v-stats-loading-text{
        display: none;
    }

    /* Gönderim/aksiyon butonları: tam genişlik, ortalı, minimal */
    .cad-actions{
        margin-left: 0;
        margin-right: 0;
        width: 100%;
    }
    .cad-actions .col-auto{
        width: 100%;
        padding-left: 0;
        padding-right: 0;
    }
    .cad-actions .btn{
        width: 100%;
        justify-content: center;
        margin-left: 0 !important;
        margin-bottom: 0.5rem;
        font-size: 0.8rem;
    }
}

/* Mobil/tablet: tablo kart görünümüne ÇEVRİLMEZ — normal tablo olarak (yatay kaydırmalı,
   ilk 3 sütun sabit) gösterilir. Eski kart-dönüşümü kaldırıldı. */

/* ---------------- Tablet (768–991.98px): tutarlar tek satır ---------------- */
@media (min-width: 768px) and (max-width: 991.98px){
    .cad-stats .row:last-child h2{
        font-size: 1.1rem;
        white-space: nowrap;
    }
    .cad-stats .row:last-child .truncate{
        overflow: visible;
        white-space: nowrap;
    }
}

/* ---------------- Tablet + orta ekranlar (768–1199.98px): üst aksiyon butonları düzgün yerleşsin ---------------- */
@media (min-width: 768px) and (max-width: 1199.98px){
    /* Arama kolonunu tam genişlik yapıp alt satıra indir; aksiyon kolonu (flex-grow)
       böylece üstte kendi satırını tek başına doldurur. (.cad-table içindeki tek col-md-4 = arama) */
    .cad-table .col-md-4{
        flex: 0 0 100%;
        max-width: 100%;
        margin-top: 0.25rem;
    }
    .cad-table .col.mb-1{
        margin-bottom: 0 !important;
    }
    /* Aksiyon butonları: ml-1 yerine eşit boşlukla sarsın ve hizalı dursun */
    .cad-actions{
        width: 100%;
        margin-left: 0;
        margin-right: 0;
    }
    .cad-actions > .col-auto{
        width: 100%;
        display: flex;
        flex-wrap: wrap;
        align-items: center;
        gap: 0.5rem;
        padding-left: 0;
        padding-right: 0;
    }
    .cad-actions .btn{
        margin: 0 !important;
    }
    /* Üst bar (filtre + butonlar) sarınca alt boşluk bıraksın */
    .cad-table > .d-flex.justify-content-between > .d-flex{
        margin-top: 0.25rem;
    }
}
</style>